"use strict";

var _inherits = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _possibleConstructorReturn = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _classCallCheck = require("C:\\Users\\the_i\\Desktop\\bachelor\\bachelor-docker\\infra\\frontend-user\\bachelor-user-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelemetryEvent = exports.Telemetry = void 0;

var abstractmessage_1 = require("./abstractmessage");

var TelemetryEvent = function TelemetryEvent(start, // relative to event send time
end, // relative to event send time
title, details, id, // optional, default will be random assigned by backend
type) {
  _classCallCheck(this, TelemetryEvent);

  this.start = start;
  this.end = end;
  this.title = title;
  this.details = details;
  this.id = id;
  this.type = type;
} // optional, default will be "SDK" assigned by backend
;

exports.TelemetryEvent = TelemetryEvent;

var Telemetry = /*#__PURE__*/function (_abstractmessage_1$Ab) {
  _inherits(Telemetry, _abstractmessage_1$Ab);

  var _super = _createSuper(Telemetry);

  function Telemetry(events) {
    var _this;

    _classCallCheck(this, Telemetry);

    _this = _super.call(this);
    _this.method = 'telemetry.v1';
    _this.events = events;
    return _this;
  }

  return Telemetry;
}(abstractmessage_1.AbstractMessage);

exports.Telemetry = Telemetry;